import config from "../Config/config";

const fetchExpensesConfirmers = async (setExpensesConfirmers) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/expensesconfirmer`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });
    if (response.ok) {
      const resJson = await response.json();
      const data = resJson.data;
      setExpensesConfirmers(data.expensesConfirmers);
    }
  } catch (error) {
    console.error("Error fetching Expenses Confirmers:", error);
  }
};

const saveExpensesConfirmers = async (expensesConfirmers, setAlert) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/expensesconfirmer`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ expensesConfirmers }),
    });
    if (response.ok) {
      setAlert({
        severity: "success",
        message: `Expenses confirmers saved`,
      });
    } else {
      setAlert({
        severity: "error",
        message: `Failed to save Expenses confirmers`,
      });
    }
  } catch (error) {
    console.error(`Failed to save Expenses confirmers: ${error}`);
    setAlert({
      severity: "error",
      message: `Failed to save Expenses confirmers: ${error}`,
    });
  }
};

export { fetchExpensesConfirmers, saveExpensesConfirmers };
